import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { FeedbackWidget } from "./components/FeedbackWidget";
import "./index.css";

/**
 * App Component
 *
 * Root component that sets up the router.
 * AuthProvider is included in the root route layout.
 */
export function App() {
  return (
    <>
      <RouterProvider router={router} />
      {/* Renders nothing on localhost, and nothing until setup:feedback has
          provisioned a project key. */}
      <FeedbackWidget />
    </>
  );
}

export default App;
